import React from "react";

const LegalDisclaimer = () => {
  return (
    <div className="w-full py-8 px-4 border-t border-border/20">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="text-sm font-medium text-muted-foreground mb-3">
          Legal Disclaimer
        </h3>
        <p className="text-xs text-muted-foreground/70 leading-relaxed">
          All visual content on this website is entirely generated by artificial intelligence. 
          None of the depicted figures, faces, bodies, or characters represent real individuals, 
          whether living or deceased. Any resemblance to actual persons, living or dead, is purely 
          coincidental and unintentional. All generated content is original and not based on real 
          photos, nor does it depict or reference real individuals. This website does not host, use, 
          or distribute material involving real people of any age.
        </p>
      </div>
    </div>
  );
};

export { LegalDisclaimer };
